import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface DownloadCampaignCSVRequest {
  token: string;
}

const downloadVirtualAccountsCSV = async ({
  token,
}: DownloadCampaignCSVRequest) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.PAYMENT)}/payment/account/download-virtual-accounts-csv`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default downloadVirtualAccountsCSV;
